/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';
import { IDescriptorBody } from '../../../descriptor';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IStringNumberPacketDataMessage extends IPackageDataMessage {
	data: string;
	data1: number;
}

export default class StringNumberPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.STRING, MessageDataTypes.NUMBER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'StringNumberPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'uint32',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: string, public readonly data1: number ) {
		super();
	}

	public toJSON(): IStringNumberPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: IStringNumberPacketDataMessage ): StringNumberPacketDataMessage {
		return new StringNumberPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: string, data1: number ): StringNumberPacketDataMessage {
		return new StringNumberPacketDataMessage( data, data1 );
	}
}
